import { jsx as _jsx } from "react/jsx-runtime";
// Keeps the route pages aligned around a single shared header implementation.
import { NavBar } from "./common/NavBar";
export default function Header() {
    return _jsx(NavBar, {});
}
